
import { Accordion } from 'react-bootstrap'
import { useTranslation } from "react-i18next"

export function OnBoardingSchool() {
    const { t } = useTranslation()
    return (
        <Accordion className='onboarding'>
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingSchool.video')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentVideo.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentVideo.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <ul>
                            <li>{t('dashboard.onboardingSchool.contentVideo.option1')}</li>
                            <li>{t('dashboard.onboardingSchool.contentVideo.option2')}</li>
                        </ul>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingSchool.interview')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentInterview.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentInterview.paragraph2')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentInterview.paragraph3')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <ul>
                            <li>{t('dashboard.onboardingSchool.contentInterview.option1')}</li>
                            <li>{t('dashboard.onboardingSchool.contentInterview.option2')}</li>
                            <li>{t('dashboard.onboardingSchool.contentInterview.option3')}</li>

                        </ul>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentInterview.paragraph4')}}></div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingSchool.offerLetter')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentOfferLetter.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentOfferLetter.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <ol>
                            <li>{t('dashboard.onboardingSchool.contentOfferLetter.option1')}</li>
                            <li>{t('dashboard.onboardingSchool.contentOfferLetter.option2')}</li>
                            <ul>
                                <li>{t('dashboard.onboardingSchool.contentOfferLetter.option2a')}</li>
                                <li>{t('dashboard.onboardingSchool.contentOfferLetter.option2b')}</li>
                            </ul>
                            <li>{t('dashboard.onboardingSchool.contentOfferLetter.option3')}</li>
                        </ol>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingSchool.incorporation')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentIncorporation.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.contentIncorporation.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <ol>
                            <li>{t('dashboard.onboardingSchool.contentIncorporation.option1')}</li>
                            <li>{t('dashboard.onboardingSchool.contentIncorporation.option2')}</li>
                            <li>{t('dashboard.onboardingSchool.contentIncorporation.option3')}</li>
                        </ol>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}

